import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Logo } from './logo.tsx';

export const LogoGroup = ({
  user,
  href,
  action = () => {},
}: {
  user: boolean;
  href: string;
  action?: () => void;
}) => (
  <span className="left-group">
    <IconButton
      size="large"
      edge="start"
      color="inherit"
      aria-label="menu"
      sx={{ mr: 2 }}
      onClick={action}
    >
      {user && <MenuIcon />}
    </IconButton>
    <Logo href={href} />
  </span>
);
